import SlimSelect from 'slim-select';

export interface SlimSelectOption {
  id?: string;
  value?: string;
  text: string;
  innerHTML?: string;
  selected?: boolean;
  display?: boolean;
  disabled?: boolean;
  placeholder?: boolean | string;
  class?: string;
  style?: string;
  data?: object;
  mandatory?: boolean;
}

export class ApplicationNotesController {
  private categorySlimSelect: SlimSelect | null = null;
  private topicButtons = document.querySelectorAll('.js-topicSelect');
  private showAllButton = document.querySelector('.applicationNotes__showAll');
  private showAll: boolean = false;

  constructor() {
    if (!(document.querySelector('.js-applicationNotes') instanceof HTMLElement)) {
      return;
    }
    this.addListeners();
    this.filter(true);
  }

  addListeners() {
    const categorySelect = document.querySelector('select.js-productCategory');
    if (categorySelect instanceof HTMLSelectElement) {
      categorySelect.addEventListener('change', () => {
        this.filter();
      });
      this.categorySlimSelect = categorySelect.slim;
    }

    this.topicButtons.forEach((topicButton) => {
      topicButton.addEventListener('click', () => {
        if (!topicButton.classList.contains('button--inactive')) {
          topicButton.classList.toggle('button--selected');
          this.filter();
        }
      });
    });
    const filterReset = document.querySelector('.js-applicationNotesReset');
    if (filterReset instanceof HTMLElement) {
      filterReset.addEventListener('click', () => {
        this.categorySlimSelect?.set('all');
        this.topicButtons.forEach((topicButton) => {
          topicButton.classList.remove('button--selected');
        });
        this.filter();
      });
    }
    if (this.showAllButton) {
      this.showAllButton.addEventListener('click', () => {
        this.showAll = true;
        this.showAllButton?.classList.add('hide');
        this.filter();
      });
    }
  }


  filter(initial: boolean = false) {
    const applicationNotes = document.querySelectorAll('.js-applicationNote');

    const possible = {
      categories: new Set<string>(),
      topics: new Set<string>(),
    };
    const active = {
      categories: this.getSelectedProductCategory(),
      topics: this.getSelectedTopics(),
    };
    applicationNotes.forEach((applicationNote, index) => {
      if (!(applicationNote instanceof HTMLElement)) {
        return;
      }
      const categories = (applicationNote.dataset.categories ?? '') + ',';
      const topics = (applicationNote.dataset.topics ?? '') + ',';
      const hasCategories = this.hasOneOf(active.categories, categories);
      const hasTopics = this.hasOneOf(active.topics, topics) || active.topics.length === 0;
      if (hasCategories) {
        topics.split(',').forEach(possible.topics.add, possible.topics);
      }
      if (hasTopics) {
        categories.split(',').forEach(possible.categories.add, possible.categories);
      }
      if (initial || (active.categories === 'all' && active.topics.length === 0) && !this.showAll) {
        if (index < 10) {
          applicationNote.classList.add('applicationNote--visible');
        } else {
          applicationNote.classList.remove('applicationNote--visible');
        }
        this.showAllButton?.classList.remove('hide');
      } else {
        applicationNote.classList.remove('applicationNote--visible');
        if (hasCategories && hasTopics) {
          applicationNote.classList.add('applicationNote--visible');
        }
        this.showAllButton?.classList.add('hide');
      }
    });
    if (applicationNotes.length < 10) {
      this.showAllButton?.classList.add('hide');
    }
    if (active.categories === 'all' && active.topics.length === 0) {
      this.showAll = false;
    }
    this.setActiveStates(possible, active, initial);
  }

  hasOneOf(needles: string | string[], haystack: string): boolean {
    if (!haystack.length) {
      return false;
    }
    if (typeof needles === 'string') {
      if (needles === 'all') {
        return true;
      }
      needles += ',';
      return haystack.indexOf(needles) > -1;
    }
    if (typeof needles === 'object') {
      if (needles.length === 0) {
        return true;
      }
      return needles.some(item => haystack.includes(item + ','));
    }
    return false;
  }

  getSelectedProductCategory(): string {
    const productCategory = document.querySelector('select.js-productCategory');
    if (!(productCategory instanceof HTMLSelectElement)) {
      return 'all';
    }
    return productCategory.value;
  }

  getSelectedTopics(): string[] {
    const topicElements = document.querySelectorAll('.js-topicSelect');
    const selectedTopics: string[] = [];
    topicElements.forEach((topic) => {
      if (topic instanceof HTMLElement && topic.classList.contains('button--selected') && topic.dataset.topic) {
        selectedTopics.push(topic.dataset.topic);
      }
    });
    return selectedTopics;
  }

  setActiveStates(
    possible: { categories: Set<string>, topics: Set<string> },
    active: { categories: string, topics: string[] },
    remove: boolean = false,
  ): void {
    this.categorySlimSelect?.data.data.forEach((option: SlimSelectOption) => {
      option.disabled = !(possible.categories.has(option.text) || option.value === 'all');
      if (option.disabled && remove) {
        option.style = 'display:none;';
      }
      return option;
    });
    this.categorySlimSelect?.render();
    const setButtonStates = (possibleOptions: Set<string>, activeOptions: string[], elements: NodeListOf<Element>) => {
      elements.forEach((button) => {
        if (activeOptions.length > 0 || possibleOptions.has(button.textContent ?? '')) {
          button.classList.remove('button--inactive');
        } else {
          button.classList.add('button--inactive');
          if (remove) {
            button.remove();
          }
        }
      });
    };
    setButtonStates(possible.topics, active.topics, this.topicButtons);
  }
}
